import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL Configuration
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID || '0360f72c-12f5-4ff5-8961-3d3eb6d14225',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID || '05d75c05-fa1a-42e7-9cf1-eb416c396f2d'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // Store tokens in localStorage
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
  },
};

// Login request configuration
export const loginRequest: PopupRequest = {
  scopes: [
    import.meta.env.VITE_SCOPE || 'api://0360f72c-12f5-4ff5-8961-3d3eb6d14225/read-user'
  ],
  prompt: 'select_account'
};

// Silent token request configuration
export const tokenRequest = {
  scopes: [
    import.meta.env.VITE_SCOPE || 'api://0360f72c-12f5-4ff5-8961-3d3eb6d14225/read-user'
  ],
};

export default msalConfig;